import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M17.8333 5.33323H17V4.4999C17 4.04156 16.625 3.66656 16.1667 3.66656C15.7083 3.66656 15.3333 4.04156 15.3333 4.4999V5.33323H8.66667V4.4999C8.66667 4.04156 8.29167 3.66656 7.83333 3.66656C7.375 3.66656 7 4.04156 7 4.4999V5.33323H6.16667C5.24167 5.33323 4.50833 6.08323 4.50833 6.9999L4.5 18.6666C4.5 19.5832 5.24167 20.3332 6.16667 20.3332H17.8333C18.75 20.3332 19.5 19.5832 19.5 18.6666V6.9999C19.5 6.08323 18.75 5.33323 17.8333 5.33323ZM17.8333 17.8332C17.8333 18.2916 17.4583 18.6666 17 18.6666H7C6.54167 18.6666 6.16667 18.2916 6.16667 17.8332V9.4999H17.8333V17.8332ZM7.83333 11.1666H9.5V12.8332H7.83333V11.1666ZM11.1667 11.1666H12.8333V12.8332H11.1667V11.1666ZM14.5 11.1666H16.1667V12.8332H14.5V11.1666Z' />
  </>,
  'Calendar'
)
